import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabaseClient";
import { useTranslation } from "react-i18next";

// Source of truth: collection_permissions
// Columns (confirmed): id, client_id, grantee_id, collection_id, can_view, can_edit, created_at, updated_at

export default function ExpertClientAccessStatus({ expertId, clientId }) {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [sharedAt, setSharedAt] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!expertId || !clientId) {
        setLoading(false);
        setHasAccess(false);
        setSharedAt(null);
       return;
      }

      setLoading(true);
      setError(null);

      const { data, error } = await supabase
       .from("collection_permissions")
        .select("id, can_view, created_at, updated_at")
        .eq("client_id", clientId)
        .eq("grantee_id", expertId)
        .eq("can_view", true)
        .order("created_at", { ascending: false })
        .limit(1);

      if (cancelled) return;

      if (error) {
        setError(error.message || t("round36.expertClientAccessStatus.readError"));
        setHasAccess(false);
        setSharedAt(null);
        setLoading(false);
        return;
      }

      const row = Array.isArray(data) ? data[0] : null;
      if (row) {
        setHasAccess(true);
        setSharedAt(row.updated_at || row.created_at || null);
      } else {
        setHasAccess(false);
        setSharedAt(null);
      }
      setLoading(false);
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [expertId, clientId, t]);

  if (loading) {
    return (
      <div style={{ fontSize: 12, color: "#57534e" }}>
        {t("round36.expertClientAccessStatus.checking")}
     </div>
    );
  }

  if (error) {
    return (
      <div style={{ fontSize: 12, color: "#b91c1c" }}>
        {error}
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div
        style={{
          fontSize: 12,
          padding: "8px 10px",
          borderRadius: 10,
          background: "#fff7ed",
          border: "1px solid #fed7aa",
          color: "#7c2d12",
        }}
      >
        {t("round36.expertClientAccessStatus.pending")}
      </div>
    );
  }

  return (
    <div
      style={{
        fontSize: 12,
        padding: "8px 10px",
        borderRadius: 10,
        background: "#f0fdf4",
        border: "1px solid #bbf7d0",
        color: "#14532d",
      }}
    >
      {sharedAt
        ? t("round36.expertClientAccessStatus.sharedOn", {
            date: new Date(sharedAt).toLocaleDateString(i18n.resolvedLanguage || i18n.language || undefined),
          })
        : t("round36.expertClientAccessStatus.shared")}
    </div>
  );
}